import AppointmentsDoctorsSingleScreen from './AppointmentsDoctorsSingleScreen';

export default AppointmentsDoctorsSingleScreen;
